export default (theme) => ({
    formLabel: {
        marginBottom:theme.spacing(1),
        color: '#212121',
    },
    image: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        backgroundImage: 'url(http://testcrm.lp-crm.biz/style/img/no_foto-120x100.png)',
        minHeight: '150px',
        width: '100%',
        height: `calc(100% - ${theme.spacing(2) + theme.spacing(1)}px)`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#3f51b5',
        marginTop: theme.spacing(2),
        marginBottom:theme.spacing(1),
        cursor: 'pointer',

        [theme.breakpoints.down('sm')]: {
            minHeight: '280px',
        },
    },

    inputWithIconButton: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-end',
    },
    categoryInput: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        '& > div:first-child': {
            width: '100%'
        },
        [theme.breakpoints.down(410)]: {
            width: 'calc(100% - 38px)'
        },
    },
    input_iconButton: {
        marginTop: '20px',
        marginRight: '0px',
    },
    input_icon: {
        marginLeft: '15px',
        marginTop: '10px',
        cursor: 'pointer',
    },

    gridSubContainer: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '12px',
                paddingRight: '12px',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
    },

    tableWrapper: {
        marginTop: theme.spacing(2),
        marginBottom:theme.spacing(1),
    },

    settingsGrid: {
        width: '100% !important',
        margin: '0 !important',

        [theme.breakpoints.down('sm')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(odd)' : {
                paddingRight: '12px',
            },
            '& .MuiGrid-root.MuiGrid-item:nth-child(even)' : {
                paddingLeft: '12px',
            },
        },
    },
});
